<template>
  <div>
    <cabecalho :ar="ar"></cabecalho>
    <div class="app-content">
      <div class="heading">Solicitação de certificado digital</div>
      <b-card class="shadow-sm mb-2 bg-white rounded">
        <wizard :steps="wizardSteps" :activeIndex="wizardActiveIndex"></wizard>
        <hr />
        <b-alert v-model="showErro" variant="danger">{{mensagemErro}}</b-alert>
        <validation-observer ref="observer" v-slot="{ passes }">
          <b-form @submit.stop.prevent="passes(enviar)">
            <validation-provider name="E-mail" rules="required|email" v-slot="validationContext">
              <b-form-group id="example-input-group-1" label="E-mail" label-for="input-mail">
                <b-form-input
                  id="input-mail"
                  name="input-mail"
                  v-model="contacts.email"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-1-live-feedback"
                  maxlength="50"
                ></b-form-input>

                <b-form-invalid-feedback
                  id="input-1-live-feedback"
                >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider name="Phone" rules="required|min:14" v-slot="validationContext">
              <b-form-group id="example-input-group-2" label="Telefone" label-for="input-phone">
                <b-form-input
                  id="input-phone"
                  name="input-phone"
                  v-model="contacts.phone"
                  v-mask="['(##) #####-####', '(##) ####-####']"
                  :state="getValidationState(validationContext)"
                  aria-describedby="input-2-live-feedback"
                ></b-form-input>

                <b-form-invalid-feedback
                  id="input-2-live-feedback"
                >{{ validationContext.errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <hr />
            <div class="botoes-wizard">
              <b-button
                onclick="history.back(-1)"
                variant="secondary"
                v-if="!loading"
                class="btn-sd mr-4"
              >Cancelar</b-button>
              <b-button
                type="submit"
                variant="primary"
                v-if="!loading"
                class="btn-sd"
                style="float:right"
              >Continuar</b-button>

              <b-button
                variant="primary"
                disabled
                v-if="loading"
                class="btn-sd"
                style="float:right"
              >
                <b-spinner small type="grow"></b-spinner>&nbsp;Enviando...
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import cabecalho from "./components/Cabecalho.vue";
import wizard from "./components/Wizard.vue";

export default {
  components: {
    cabecalho,
    wizard
  },
  data() {
    return {
      contacts: {
        email: null,
        phone: null
      },
      mensagemErro: null,
      showErro: false,
      loading: false
    };
  },
  computed: {
    ar: function() {
      var arAndCertificate = sessionStorage.getItem("arAndCertificate");
      if (arAndCertificate != null) {
        return JSON.parse(arAndCertificate);
      }
      return null;
    },
    wizardSteps: function(){
     return ["Identificação", "Contato", "Informações Adicionais", "Confirmação"];
    },
    wizardActiveIndex: function(){
      return 1;
    }
  },
  methods: {
    enviar: function() {
      this.loading = true;
      this.showErro = false;
      this.$http
        .post(this.$serviceUrl + "/order/contacts", this.contacts, {
          headers: {
            Authorization: sessionStorage.getItem("token")
          }
        })
        .then(
          resp => {
            sessionStorage.setItem("token", resp.bodyText);
            this.$router.replace("/order/step/email/confirmation");
          },
          resp => {
            if (resp.status == 404) {
              this.mensagemErro = "Não encontrado";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.loading = false;
          }
        );
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/Contacts.vue